import React, { useContext } from 'react'

import { faFlaskGear, faGlobeEurope, faSignOutAlt } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Dropdown, Menu, Tooltip } from 'antd'
import { bindActionCreators } from 'redux'
import Cookie from 'js-cookie'
import { connect } from 'react-redux'
import { addTranslationForLanguage, getActiveLanguage, getLanguages, getTranslate, setActiveLanguage } from 'react-localize-redux'

import { setLanguage } from '../../utils/locale'
import { getUser, updateUserProfile } from '../../reducers/UserReducer'
import { updateUser } from '../../utils/api/user'
import UserSettings from './UserSettings'
import { GlobalContext } from '../../Providers/GlobalProvider'
import { ColorsPalette } from '../../config/colors'
import { Cookies } from '../../utils/Cookie'

const mapStateToProps = state => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  languages: getLanguages(state.locale),
  t: getTranslate(state.locale),
  user: getUser(state.getUser)
})

const mapDispatchToProps = dispatch => ({
  addTranslation: bindActionCreators(addTranslationForLanguage, dispatch),
  setActiveLanguage: bindActionCreators(setActiveLanguage, dispatch),
  updateUserProfile: bindActionCreators(updateUserProfile, dispatch)
})

const LanguagesMenu = ({ currentLanguage, icon, languages, title, type, user, t, addTranslation, onLogout, setActiveLanguage, updateUserProfile }) => {
  const { invalidateEventCodes } = useContext(GlobalContext)
  const { betaMode } = useContext(GlobalContext)

  const updateUserLanguage = language => {
    if (user.id && user.language !== language) {
      updateUser(user, { id: user.id, language }).then(json => {
        updateUserProfile(json.data)
        invalidateEventCodes()
        if (
          typeof Cookie.get('user') !== 'undefined' &&
            Cookie.get('user') !== 'undefined' &&
            typeof Cookie.get('token') !== 'undefined' &&
            Cookie.get('token') !== 'undefined'
        ) {
          Cookie.set(Cookies.USER, JSON.stringify(json.data), { expires: 7 })
        }
      })
    }
  }

  const renderMenu = () => {
    let menuItems = []

    if (onLogout) {
      menuItems = [
        <Menu.Item key='menu-item-1'>
          <UserSettings />
        </Menu.Item>,
        <Menu.Divider key='menu-divider-1' />,
        <Menu.Item key='menu-item-2' onClick={onLogout}>
          <FontAwesomeIcon icon={faSignOutAlt} color={ColorsPalette.BLUE_ICON} />
          {t('Log out')}
        </Menu.Item>,
        <Menu.Divider key='menu-divider-2' />,
        <Menu.Item key='menu-item-3' onClick={() => betaMode.toggle()}>
          <FontAwesomeIcon icon={faFlaskGear} color={betaMode.active ? ColorsPalette.LIGHT_MOSS_GREEN : ColorsPalette.BLUE_ICON} />
          {t('global_settings.beta_mode')}
        </Menu.Item>,
        <Menu.Divider key='menu-divider-3' />
      ]
    }

    languages.forEach(l => {
      menuItems.push(
        <Menu.Item
          key={l.code} onClick={e => {
            setLanguage({
              language: e.key,
              addTranslationForLanguage: addTranslation,
              setActiveLanguage,
              getActiveLanguage,
              getUser: () => { return user }
            })
            updateUserLanguage(e.key)
          }}
          className='ant-dropdown-menu-item'
        >
          <FontAwesomeIcon
            icon={faGlobeEurope}
            style={{
              color: currentLanguage === l.code
                ? ColorsPalette.BLUE_ICON
                : 'transparent'
            }}
          />
          {t(l.name)}
        </Menu.Item>
      )
    })

    return (
      <Menu>
        {menuItems}
      </Menu>
    )
  }

  return (
    <Dropdown
      overlay={renderMenu()}
      trigger={['click']}
    >
      <Tooltip placement='left' title={title}>
        <Button type={type ?? 'default'}>
          <FontAwesomeIcon icon={icon} />
        </Button>
      </Tooltip>
    </Dropdown>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguagesMenu)
